/* tslint:disable */
/* eslint-disable */
/**
 * David Master Api
 * db: david-master
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { SignDTOFromJSON, SignDTOListBaseResponseFromJSON, } from '../models';
/**
 *
 */
export class SignApi extends runtime.BaseAPI {
    /**
     */
    apiSignEntIdDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.entId === null || requestParameters.entId === undefined) {
                throw new runtime.RequiredError('entId', 'Required parameter requestParameters.entId was null or undefined when calling apiSignEntIdDelete.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Sign/{entId}`.replace(`{${"entId"}}`, encodeURIComponent(String(requestParameters.entId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiSignEntIdDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiSignEntIdDeleteRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    apiSignEntIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.entId === null || requestParameters.entId === undefined) {
                throw new runtime.RequiredError('entId', 'Required parameter requestParameters.entId was null or undefined when calling apiSignEntIdGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Sign/{entId}`.replace(`{${"entId"}}`, encodeURIComponent(String(requestParameters.entId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SignDTOFromJSON(jsonValue));
        });
    }
    /**
     */
    apiSignEntIdGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiSignEntIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiSignEntIdPutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.entId === null || requestParameters.entId === undefined) {
                throw new runtime.RequiredError('entId', 'Required parameter requestParameters.entId was null or undefined when calling apiSignEntIdPut.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters.title !== undefined) {
                formParams.append('Title', requestParameters.title);
            }
            if (requestParameters.description !== undefined) {
                formParams.append('Description', requestParameters.description);
            }
            if (requestParameters.url !== undefined) {
                formParams.append('Url', requestParameters.url);
            }
            if (requestParameters.file !== undefined) {
                formParams.append('File', requestParameters.file);
            }
            const response = yield this.request({
                path: `/api/Sign/{entId}`.replace(`{${"entId"}}`, encodeURIComponent(String(requestParameters.entId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SignDTOFromJSON(jsonValue));
        });
    }
    /**
     */
    apiSignEntIdPut(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiSignEntIdPutRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiSignGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.page !== undefined) {
                queryParameters['page'] = requestParameters.page;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['pageSize'] = requestParameters.pageSize;
            }
            if (requestParameters.orderBy !== undefined) {
                queryParameters['orderBy'] = requestParameters.orderBy;
            }
            if (requestParameters.orderByDir !== undefined) {
                queryParameters['orderByDir'] = requestParameters.orderByDir;
            }
            if (requestParameters.title !== undefined) {
                queryParameters['title'] = requestParameters.title;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Sign`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SignDTOListBaseResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiSignGet(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiSignGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiSignGetLibraryGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Sign/getLibrary`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SignDTOFromJSON));
        });
    }
    /**
     */
    apiSignGetLibraryGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiSignGetLibraryGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiSignPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters.title !== undefined) {
                formParams.append('Title', requestParameters.title);
            }
            if (requestParameters.description !== undefined) {
                formParams.append('Description', requestParameters.description);
            }
            if (requestParameters.url !== undefined) {
                formParams.append('Url', requestParameters.url);
            }
            if (requestParameters.file !== undefined) {
                formParams.append('File', requestParameters.file);
            }
            const response = yield this.request({
                path: `/api/Sign`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SignDTOFromJSON(jsonValue));
        });
    }
    /**
     */
    apiSignPost(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiSignPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
